import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

const HeroSection = () => {
  const navigate = useNavigate();
  const { userId, isAuth, logout } = useAuth();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Cute%20colorful%203D%20avatar%20characters%20teaching%20live%20online%20classes%20in%20a%20bright%20cheerful%20virtual%20classroom%20setting%20with%20holographic%20screens%20floating%20books%20digital%20whiteboards%20and%20interactive%20learning%20elements%20adorable%20animal-like%20teacher%20avatars%20with%20friendly%20expressions%20conducting%20engaging%20lessons%20for%20children%20modern%20educational%20technology%20background%20with%20soft%20pastel%20colors%20and%20playful%20atmosphere&width=1920&height=1080&seq=hero-avatar-bg-001&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-purple-900/60"></div>
      </div>

      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-20 md:py-6 md:px-4 py-2 px-2">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="md:w-10 md:h-10 w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold md:text-xl text-md">
                AI
              </span>
            </div>
            <span className="text-white font-bold text-sm md:text-xl whitespace-nowrap">
              AIKnow 라이브 클래스
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#features"
              className="text-white hover:text-blue-200 transition-colors"
            >
              수업 소개
            </a>
            <a
              href="#classes"
              className="text-white hover:text-blue-200 transition-colors"
            >
              인기 수업
            </a>
            <a
              href="#teachers"
              className="text-white hover:text-blue-200 transition-colors"
            >
              선생님
            </a>
            <a
              href="http://pf.kakao.com/_ePxdpn"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-200 transition-colors"
            >
              문의하기
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-2 md:space-x-4">
            {isAuth && (
              <button
                onClick={() => navigate('/member/mypage')}
                className="text-white text-m px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
              >
                {userId}님
              </button>
            )}
            <button
              onClick={isAuth ? logout : () => navigate('/member/login')}
              className="text-white text-m px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
            >
              {isAuth ? '로그아웃' : '로그인'}
            </button>
            <a
              href="https://www.youtube.com/@first-aiknow/shorts"
              target="_blank"
              className="md:text-lg text-xs bg-gradient-to-r from-blue-500 to-purple-600 text-white md:px-6 px-2 py-2 rounded-full hover:from-blue-600 hover:to-purple-700 transition-all whitespace-nowrap"
            >
              AI시대 자녀 교육
            </a>
          </div>
        </div>
      </nav>

      <div className="absolute top-12 left-0 z-20 px-2 flex md:hidden items-center justify-end gap-2">
        {isAuth && (
          <button
            onClick={() => navigate('/member/mypage')}
            className="text-white text-xs px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
          >
            {userId}님
          </button>
        )}
        <button
          onClick={isAuth ? logout : () => navigate('/member/login')}
          className="text-white text-xs px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
        >
          {isAuth ? '로그아웃' : '로그인'}
        </button>
        <a
          href="https://www.youtube.com/@first-aiknow/shorts"
          target="_blank"
          className="md:text-lg text-xs bg-gradient-to-r from-blue-500 to-purple-600 text-white md:px-6 px-2 py-2 rounded-full hover:from-blue-600 hover:to-purple-700 transition-all whitespace-nowrap"
        >
          AI시대 자녀 교육
        </a>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center text-white pt-24 pb-14 md:pt-20 md:pb-4 flex flex-col items-center gap-8 md:gap-12">
        {/* 카카오톡 상담 배너 */}
        <div className="w-full max-w-[880px]">
          <div
            className="flex items-center justify-between gap-2 md:gap-4 py-2.5 px-5 md:px-20 md:py-4 rounded-full shadow-lg border border-[#3a2929]/10"
            style={{
              background:
                'linear-gradient(90deg, #FFE84A 0%, #FEE500 38%, #FFF3A2 100%)'
            }}
          >
            <div className="flex items-center gap-2 md:gap-3 min-w-0 text-left">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 bg-[#3A2929] rounded-xl flex items-center justify-center text-[#FEE500]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="md:w-6 md:h-6"
                >
                  <path
                    d="M12 4C6.96 4 3 7.2 3 11.18c0 2.58 1.67 4.84 4.18 6.1l-.72 2.66c-.09.33.29.59.57.39l3.24-2.23c.56.08 1.14.12 1.73.12 5.04 0 9-3.2 9-7.04C21 7.2 17.04 4 12 4Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="flex flex-col min-w-0">
                <span className="text-[#3A2929] text-[13px] md:text-sm font-black md:font-bold tracking-tight">
                  KakaoTalk 상담 오픈 · 빠른 답변
                </span>
                <p className="text-[#231815] text-sm md:text-lg font-black tracking-tighter truncate max-w-[180px] sm:max-w-none hidden md:block">
                  AI 라이브 수업이 궁금하다면? 지금 카카오톡 오픈방에서 1:1로
                  물어보세요!
                </p>
              </div>
            </div>

            {/* 버튼 그룹 */}
            <div className="flex items-center gap-1 md:gap-2 flex-shrink-0">
              <a
                href="https://pf.kakao.com/_xjDIdX"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1 bg-gradient-to-br from-[#2668FF] to-[#7B4DFF] text-white text-[11px] md:text-sm font-black px-3 md:px-4 py-3 rounded-full shadow-md hover:scale-105 transition-transform whitespace-nowrap"
              >
                <span>오픈방 1:1 상담하기</span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.75 3.5L10.25 8L5.75 12.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 text-center text-white md:pt-0">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-5xl/[1.2] font-bold mb-6 leading-tight">
              <span className="block">AI 아바타 선생님과 함께하는</span>
              <span className="block bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                라이브 클래스
              </span>
            </h1>

            <p className="text-sm md:text-xl md:mb-8 mb-6 text-gray-200 leading-relaxed tracking-tight">
              초등학생을 위한 개인 맞춤형 AI 라이브 교육으로
              <br />
              재미있게 배우고 실력을 키워보세요
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 md:mb-12 mb-6">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (isAuth) {
                    navigate('/passport');
                  } else {
                    alert('로그인 후 이용해주세요');
                    navigate('/member/login');
                  }
                }}
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-blue-500 to-purple-600 text-white md:px-8 px-4 md:py-4 py-2 rounded-full md:text-lg text-md font-bold hover:from-blue-600 hover:to-purple-700 transition-all transform hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>내 AI탐험여권 보기
              </a>
              <a
                href="#monthly-works"
                className="border-2 border-white text-white md:px-8 px-4 md:py-4 py-2 rounded-full md:text-lg text-md font-bold hover:bg-white hover:text-purple-600 transition-all whitespace-nowrap"
              >
                <i className="ri-video-line mr-2"></i>이 달의 학생작품
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 md:gap-8 gap-2 md:mt-16 mt-6">
              <div className="text-center">
                <div className="md:text-4xl text-2xl font-bold text-blue-400 mb-2">
                  10,000+
                </div>
                <div className="text-gray-300">수강생</div>
              </div>
              <div className="text-center">
                <div className="md:text-4xl text-2xl font-bold text-purple-400 mb-2">
                  500+
                </div>
                <div className="text-gray-300">AI 수업</div>
              </div>
              <div className="text-center">
                <div className="md:text-4xl text-2xl font-bold text-pink-400 mb-2">
                  98%
                </div>
                <div className="text-gray-300">만족도</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
